import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteChat } from "../../../routes/Chat/chat.ducks";
import { notification, getCroatianPluralForm } from "../../../services";
import { Chat } from "../../../typings/interfaces";

const getDeleteNotificationMessage = (count: number): string => {
  return `${count} ${getCroatianPluralForm(
    count,
    "razgovor je obrisan",
    "razgovora su obrisana",
    "razgovora je obrisano"
  )}`;
};

export const useDeleteChats = (chats: Chat[]) => {
  const dispatch = useDispatch();

  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedChats, setSelectedChats] = useState([]);


  const handleBatchDelete = () => {
    if (selectedChats.length === 0) return;

    setIsDeleting(true);
    dispatch(deleteChat(selectedChats, (success, error) => {
      setIsDeleting(false);
      if (success) {
        notification.show(getDeleteNotificationMessage(selectedChats.length));
        setSelectedChats([]);
      } else {
        notification.showError("Greška pri brisanju razgovora");
      }
    }));
  }

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedChats(chats.map(chat => chat.chatId));
    } else {
      setSelectedChats([]);
    }
  }

    const isAllSelected = chats.length > 0 && selectedChats.length === chats.length;


  return {
    isAllSelected,
    handleSelectAll,
    isDeleting,
    setSelectedChats,
    handleBatchDelete,
    selectedChats,
  }

}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/hooks/useDeleteChats.ts